import axios from "axios";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_URL, timeout: 30000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("botfull_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.includes("/auth/login")) {
      localStorage.removeItem("botfull_token");
      window.dispatchEvent(new Event("botfull:unauthorized"));
    }
    return Promise.reject(error);
  },
);

export const errorMessage = (error) =>
  error.response?.data?.detail || "Não foi possível concluir a operação.";